import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, Popup } from 'semantic-ui-react';
import moment from 'moment';

import { DATE_FORMAT_DATE_TIME_12H } from 'Common/Constants/dateformat';

import 'Styles/components/user-modified.less';

class UserModified extends Component {
  static propTypes = {
    user: PropTypes.string.isRequired,
    modifiedDT: PropTypes.string.isRequired,
  };

  render() {
    const { user, modifiedDT } = this.props;
    const content = (
      <div>
        <strong>User Modified:</strong>
        <br />
        {user}
        <br />
        {moment(modifiedDT).format(DATE_FORMAT_DATE_TIME_12H)}
      </div>
    );

    return (
      <div className="user-modified-container">
        <Popup
          style={{ zIndex: 1000000 }}
          trigger={<Icon name={'exclamation circle'} />}
          content={content}
          on="hover"
        />
      </div>
    );
  }
}

export { UserModified };



// WEBPACK FOOTER //
// ./src/common/Components/UserModified/UserModified.js